import { CheckIcon } from 'lucide-react'
import styled from 'styled-components'

import { BasicComponent } from './FilesTable'

const StyledComponentSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`

const StyledCheckboxContainer = styled.div`
  padding: 0.5rem;
  display: flex;
  height: 3rem;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }) => theme.forecast.cardBackground};
  border-radius: 0.25rem;
`

const StyledCheckboxIcon = styled.div`
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 0.25rem;
  margin-right: 0.875rem;
  background-color: ${({ theme }) => theme.forecast.defaultButton};
  justify-content: center;
  align-items: center;
  display: flex;

  &:hover {
    background-color: ${({ theme }) => theme.forecast.hoverButton};
  }
`

interface EditTagsModalProps {
  componentsTags: BasicComponent[]
  setComponentsTags: (componentsTags: BasicComponent[]) => void
  components: BasicComponent[]
}

export const EditTagsModal: React.FC<EditTagsModalProps> = ({
  componentsTags,
  setComponentsTags,
  components,
}: EditTagsModalProps) => {
  const handleComponentClick = (
    event: React.MouseEvent<HTMLDivElement>,
    componentId: string
  ) => {
    event.stopPropagation()

    const isComponentSelected = componentsTags.some(
      (tag) => tag.id === componentId
    )
    const componentToToggle = { id: componentId, name: componentId }

    if (isComponentSelected) {
      const updatedTags = componentsTags.filter((tag) => tag.id !== componentId)
      setComponentsTags(updatedTags)
    } else {
      const updatedTags = [...componentsTags, componentToToggle]
      setComponentsTags(updatedTags)
    }
  }

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <StyledComponentSelectContainer>
        {components.map((component) => (
          <StyledCheckboxContainer key={component.id}>
            <StyledCheckboxIcon
              aria-role='checkbox'
              role='checkbox'
              data-testid={`component-checkbox-${component.id}`}
              onClick={(event) => handleComponentClick(event, component.id)}>
              {componentsTags.some((tag) => tag.id === component.id) && (
                <CheckIcon />
              )}
            </StyledCheckboxIcon>
            {component.name}
          </StyledCheckboxContainer>
        ))}
      </StyledComponentSelectContainer>
    </div>
  )
}
